'use client'

import { Spinner } from '@/components/extension/spinner'
import { ProductFormatted } from '@/types/product'
import {
  ProductCardProvider,
  useProductCardContext,
} from './context/product-card-context'
import { ProductItemInfo } from './product-item-info'
import { ProductItemThumbnail } from './product-item-thumbnail'

type Props = {
  product: ProductFormatted
  gaTrackingValue?: string
  gaTrackingLabel?: string
}

const ProductCardContent = ({
  gaTrackingValue,
  gaTrackingLabel,
}: {
  gaTrackingValue?: string
  gaTrackingLabel?: string
}) => {
  const { isPendingAddToCart } = useProductCardContext()

  return (
    <div className='relative w-full shrink-0 grow-0'>
      {isPendingAddToCart ? (
        <div
          className='absolute inset-0 z-10 flex items-center justify-center bg-neutral-100/50'
          role='status'
          aria-label='Adding to cart'
        >
          <Spinner size='large' />
        </div>
      ) : null}
      <figure className='space-y-3' role='group' aria-label='Product card'>
        <ProductItemThumbnail
          gaTrackingValue={gaTrackingValue}
          gaTrackingLabel={gaTrackingLabel}
        />
        <ProductItemInfo
          gaTrackingValue={gaTrackingValue}
          gaTrackingLabel={gaTrackingLabel}
        />
      </figure>
    </div>
  )
}

export const ProductCard = ({
  product,
  gaTrackingValue,
  gaTrackingLabel,
}: Props) => {
  return (
    <ProductCardProvider product={product}>
      <ProductCardContent
        gaTrackingValue={gaTrackingValue}
        gaTrackingLabel={gaTrackingLabel}
      />
    </ProductCardProvider>
  )
}
